import type { DownloadedFile } from '@/lib/api'

/** Entrega ao navegador o arquivo que a API devolveu, com o nome que ela deu. */
export function saveFile(file: DownloadedFile, fallbackName: string) {
  const url = URL.createObjectURL(file.blob)
  const link = document.createElement('a')
  link.href = url
  link.download = file.fileName ?? fallbackName
  document.body.append(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
